import { useReactTable } from "@tanstack/react-table";
import React, { useState } from "react";
import { Payment } from "./PaymentsPage";
import { Button, Select } from "@aidkitorg/component-library";
import { SelectOptionType } from "@aidkitorg/component-library/dist/types/src/Select";

const STATUS_FILTER_VALUES: Array<SelectOptionType> = [
  {
    value: "",
    label: "All statuses",
  },
  {
    value: "approved",
    label: "Approved",
  },
  {
    value: "pending_approval",
    label: "Pending Approval"
  }
]

export type PaymentsFilterProps = {
  table: ReturnType<typeof useReactTable<Payment>>
}

type Filters = {
  status: string,
  start: string,
  end: string,
}

export const PaymentsFilter: React.FC<PaymentsFilterProps> = ({table}) => {
  const [filters, setFilters] = useState<Filters>({
    status: "",
    start: "",
    end: "",
  })

  const applyFilters = () => {
    const statusCol = table.getColumn("status")
    const dateCol = table.getColumn("paymentDate")

    statusCol?.setFilterValue(filters.status || undefined)

    dateCol?.setFilterValue(
      filters.start || filters.end
        ? { start: filters.start, end: filters.end }
        : undefined
    )
    console.log(filters)
    
  }

  const resetFilters = () => {
    setFilters({ status: "", start: "", end: "" })
    table.resetColumnFilters()
  }

  const getStatusOption = (value: string) => (STATUS_FILTER_VALUES.find((v) => v.value === value))

  return (
    <div>
      <div className="flex gap-4">
        <div>
          <Select className="min-h-10" options={STATUS_FILTER_VALUES} description="Filter by status" label="Status" labelLocation="above" value={getStatusOption(filters.status)} onChange={(value) => setFilters(f => ({... f, status: value.value}))}/>
        </div>
        <div>
          <label className="block text-sm/6 font-medium text-gray-900 mb-1">Payment Date</label>
          <div className="flex items-center gap-2">
            <input
              type="date"
              value={filters.start}
              onChange={(e) => setFilters(f => ({ ...f, start: e.target.value }))}
              className="min-height-10 border px-3 py-2 rounded-md text-sm shadow-sm"
            />
            <span className="text-gray-500">to</span>
            <input
              type="date"
              value={filters.end}
              onChange={(e) => setFilters(f => ({ ...f, end: e.target.value }))}
              className="min-h-10 border px-3 py-2 rounded-md text-sm shadow-sm"
            />
          </div>
        </div>
      </div>
      <div className="pt-4">
        <div className="flex gap-2">
          <Button variant="secondary" onClick={resetFilters}>Reset Filters</Button>
          <Button onClick={applyFilters}>Apply Filters</Button>
        </div>
      </div>  
    </div>)
}